<template>
  <div>
    <div class="page-container content0 px-3 py-2">
      <div class="fixed-header px-3">
        <div class="card card0">
          <Toolbar class="card0">
            <template #start>
              <div
                class="flex items-center gap-2 header-profile"
                @click="visibleProfile = true"
              >
                <Avatar
                  image="https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png"
                  shape="square"
                  size="large"
                  class="testcss"
                /><span class="inline-flex flex-col items-start">
                  <span class="font-bold"><!-- Иванов И.И. --></span>
                </span>
              </div>
            </template>

            <template #center> </template>

            <template #end>
              <div class="flex items-center gap-2">
                <OverlayBadge value="3" size="small">
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.5rem; color: gray"
                  />
                </OverlayBadge>
              </div>
            </template>
          </Toolbar>
        </div>
      </div>
      <div class="scrollable-content">
        <div
          class="d-block main-block pt-2 text-start ps-3 pb-3"
          style="font-weight: 400; font-size: 14pt"
        >
          Добро пожаловать,
          <span
            class="d-block"
            style="font-weight: 500; font-size: 20pt; line-height: 1"
            >{{ profile.first_name }}</span
          >
        </div>
        <!-- <div class="main-block pt-4">
      <div class="d-flex row px-2">
        <div class="d-flex col-12">
          <div class="d-flex col-6 p-0 m-0 cdiv">
            <div class="cblock me-2 w-100 text-start">
              <div><RiskWidget></RiskWidget></div>
            </div>
          </div>
          <div class="d-flex col-6 p-0 m-0 cdiv">
            <div class="cblock ms-2 w-100 text-start">
              <div>
                <LipProfileWidget @click="visible = true"></LipProfileWidget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

        <div class="main-block pt-2">
          <div class="d-flex row ps-2">
            <div class="d-flex col-12">
              <div class="d-flex col-6 p-0 m-0 cdiv">
                <div class="me-1 w-100 text-start">
                  <div>
                    <RiskWidget @click="visibleRisk = true"></RiskWidget>
                  </div>
                </div>
              </div>
              <div class="d-flex col-6 p-0 m-0 cdiv">
                <div class="ms-1 me-2 w-100 text-start">
                  <div>
                    <LipProfileWidget
                      @click="visible = true"
                    ></LipProfileWidget>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-block pt-0">
          <div class="d-flex row ps-2">
            <div class="d-flex col-12">
              <div class="d-flex col-6 p-0 m-0 cdiv">
                <div class="cblock me-1 w-100 text-start">
                  <div>
                    <VesDynWidget @click="visibleBottom = true"></VesDynWidget>
                  </div>
                </div>
              </div>
              <div class="d-flex col-6 p-0 m-0 cdiv" @click="navigateToDoctors">
                <div class="cblock2 ms-1 me-2 w-100 text-start">
                  <div><DocBookWidget></DocBookWidget></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="recommendations px-2">
          <h2 class="recommendations__title ps-2 pt-4 text-start">
            Мои рекомендации
          </h2>

          <div class="recommendations__container">
            <div class="recommendations__scroll">
              <div
                v-for="(article, index) in articles"
                :key="index"
                class="article-card text-start"
              >
                <div class="article-card__header">
                  <h3 class="article-card__title">{{ article.title }}</h3>
                  <span class="article-card__time">{{ article.time }}</span>
                </div>
                <p class="article-card__preview">{{ article.preview }}</p>
              </div>
            </div>
          </div>
        </div>
        <footer></footer>

        <Drawer
          v-model:visible="visible"
          header="Липидный профиль"
          position="bottom"
          class="drawer-fullscreen"
        >
          <!-- Контент Drawer -->
          <LipProfilePage></LipProfilePage>
        </Drawer>

        <Drawer
          v-model:visible="visibleRisk"
          header="Персональный риск"
          position="bottom"
          class="drawer-fullscreen"
        >
          <RiskProfilePage></RiskProfilePage>
        </Drawer>

        <Drawer
          v-model:visible="visibleBottom"
          header="Масса тела"
          position="bottom"
          class="drawer-fullscreen"
        >
          <WeightBlock></WeightBlock>
        </Drawer>
        <Drawer
          v-model:visible="visibleProfile"
          header="Профиль"
          position="top"
          class="drawer-fullscreen"
        >
          <ProfilePage></ProfilePage>
        </Drawer>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import RiskWidget from "../views/widgets/RiskWidget.vue";
import LipProfilePage from "./pages/LipProfilePage.vue";
import LipProfileWidget from "./widgets/LipProfileWidget.vue";
import { handleError, ref } from "vue";
import { defineComponent, onMounted } from "vue";
import VesDynWidget from "./widgets/VesDynWidget.vue";
import DocBookWidget from "./widgets/DocBookWidget.vue";
import { useRouter } from "vue-router";
import WeightBlock from "./widgets/WeightBlock.vue";
import RiskProfilePage from "./pages/RiskProfilePage.vue";
import ProfilePage from "./pages/ProfilePage.vue";
import { fetchLipids_onlyapi } from "@/services/api";
import { loadFromLocalDB } from "@/services/dataService";

interface Article {
  title: string;
  preview: string;
  time: string;
}

export default defineComponent({
  data() {
    return {
      articles: [
        {
          title: "Здоровое питание",
          preview: "Основы правильного питания для здоровья",
          time: "5 мин",
        },
        {
          title: "Физическая активность",
          preview: "Ежедневные упражнения для поддержания формы",
          time: "7 мин",
        },
        {
          title: "Сон и здоровье",
          preview: "Важность режима сна",
          time: "4 мин",
        },
      ] as Article[],
    };
  },
  setup() {
    const visible = ref(false);
    const visibleBottom = ref(false);
    const visibleRisk = ref(false);
    const visibleProfile = ref(false);
    const router = useRouter();
    const isLoading = ref(false); // Добавляем isLoading
    const errorMessage = ref(""); // Сообщение об ошибке
    const successMessage = ref(""); // Сообщение об успехе
    const navigateToDoctors = () => {
      router.push({ name: "DoctorsPage" });
    };

    const handleHome = async () => {
      try {
        const result = await fetchLipids_onlyapi();
        // Если успешно, сохраняем сообщение
        successMessage.value = result.message;
        // eslint-disable-next-line
      } catch (error: any) {
        // Показываем сообщение об ошибке
        errorMessage.value = error.message;
      }
    };

    const profile = ref({ first_name: "" });

    onMounted(async () => {
      try {
        const data = await loadFromLocalDB("profile");
        if (data) {
          profile.value = data;
        }
      } catch (error) {
        console.error("Ошибка загрузки профиля:", error);
      }
    });

    return {
      visible,
      navigateToDoctors,
      visibleBottom,
      visibleRisk,
      visibleProfile,
      isLoading,
      handleHome,
      profile,
    };
  },

  components: {
    RiskWidget,
    LipProfileWidget,
    LipProfilePage,
    VesDynWidget,
    DocBookWidget,
    WeightBlock,
    RiskProfilePage,
    ProfilePage,
  },
});
</script>
<style lang="scss">
body {
  touch-action: none; /* Блокировка масштабирования и перетаскивания */
  overscroll-behavior: auto;
  scroll-behavior: smooth;
}
.testcss img {
  border-radius: 20px;
  overflow: hidden;
}
.content0 {
  background: none;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden; /* Блокировка вертикального масштабирования */
}
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background: #f8f9fa; /* Цвет фона */
}

.scrollable-content {
  margin-top: 60px; /* Высота фиксированного верхнего бара */
  overflow-x: hidden; /* Отключение горизонтального скролла */
  padding-bottom: 20px; /* Отступ для нижнего контента */
  overflow-y: auto; /* Включает вертикальный скролл */
  -webkit-overflow-scrolling: touch; /* Плавность на iOS устройствах */
  flex-grow: 1;
  transform: translate3d(0px, 0px, 0px);
  scroll-behavior: smooth;
  color: var(--p-drawer-color);
  display: block;
}

.header-profile {
  vertical-align: middle;
  display: flex;
  align-content: center;
  align-items: center;
}
.card0 {
  background: none !important;
  border: none !important;
}
.cdiv {
  /*   background: #6a6a6a; */
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.cblock {
  background: linear-gradient(115deg, #e3e3e3, transparent);
  border-radius: 10px;

  box-shadow: 2px 2px 5px 0px #ccc;
}

.cblock2 {
  background: linear-gradient(115deg, #e3e3e3, transparent);

  border-radius: 10px;
  box-shadow: 2px 2px 5px 0px #ccc;
}
.drawer-fullscreen {
  height: 100% !important;
  max-height: 100% !important;
  background-color: #f8f9fa !important;
  background-color: #f8f9fa !important;
  border: 0;
}
.drawer-weight {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #f8f9fa !important;
  border: 0;
}
.p-button-secondary:focus-visible {
  text-decoration: none !important; /* Эффект при наведении */
  box-shadow: none !important;
  border: none !important;
}

.p-button-secondary:active {
  text-decoration: none !important; /* Эффект при наведении */
  box-shadow: none !important;
  border: none !important;
}

.p-button-secondary:hover {
  text-decoration: none !important; /* Эффект при наведении */
  box-shadow: none !important;
  border: none !important;
}

.recommendations {
  width: 100vw;

  &__title {
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 0.75rem;
    padding-left: 0.25rem;
  }

  &__container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__scroll {
    display: flex;
    gap: 0.75rem;
    padding-bottom: 1rem;
  }
}

.article-card {
  min-width: 280px;
  padding: 1rem;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 1px 1px 9px 0px #efefef;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.5rem;
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 500;
  }

  &__time {
    font-size: 0.875rem;
    color: #6b7280;
  }

  &__preview {
    color: #4b5563;
  }
}
</style>
